export const SEPARATE_LEAD_FORM_STRUCT_KEY = 'struct'
export const INTEGRATED_LEAD_FORM_STRUCT_KEY = 'leadFormStruct'
